export enum Locale {
  ZH_CN = 'zh-CN',
  EN_US = 'en-US',
}

export const LocaleLabels: Record<Locale, { short: string; full: string }> = {
  [Locale.ZH_CN]: { short: '中', full: '中文' },
  [Locale.EN_US]: { short: 'EN', full: 'English' },
};

export const SUPPORTED_LOCALES = Object.values(Locale);
export const DEFAULT_LOCALE = Locale.EN_US;
